import { combineReducers } from 'redux';
import generalReducer from './general';
import userReducer from './userState';

const rootReducer = combineReducers({
  generalReducer,
  userReducer
});

export default rootReducer;
